module.exports = __webpack_public_path__ + "static/media/shop_icon.0e0b3b9f.svg";